
//import http, { requestConfig } from "../../../../Dataplan.Excel.WebAddin/src/Utilities/http-common";
import { getAxiosInstance, requestConfig } from "../../http-common";
// import { DataTypeItem, FieldWithUpdate, Issue, Label, Table, Update } from "../../../../Dataplan.Excel.WebAddin/src/models";
// import { AggregatedIssue } from ".../../../../Dataplan.Excel.WebAddin/src/models/aggregated-issue.dto";
// import { createSemanticDiagnosticsBuilderProgram } from "typescript";

const ROUTE_NAME = "datashaper";

const getEntities = (user: string, groupCode: string | undefined) => {

    const http = getAxiosInstance();
    return http.get<string[]>(`${ROUTE_NAME}/entities`, { ...requestConfig(), params: { user, groupCode } });
};

const getGroupCodes = (user: string, viewId: number) => {

    const http = getAxiosInstance();

    return http.get(`${ROUTE_NAME}/groupCodes`, { ...requestConfig(), params: { user, viewId } });
};

const getTables = (user: string) => {

    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/tables`, { ...requestConfig(), params: { user } });
};

const getEnvironments = (user: string, viewId: number) => {

    const http = getAxiosInstance();
    return http.get(`${ROUTE_NAME}/environments`, { ...requestConfig(), params: { user, viewId } });
};

const getEditableFields = (viewId: number | string) => {

    const http = getAxiosInstance();
    return http.get(`${ROUTE_NAME}/editableFields`, { ...requestConfig(), params: { viewId } });
};

const getVisibleFields = (viewId: number) => {

    const http = getAxiosInstance();
    return http.get(`${ROUTE_NAME}/visibleFields`, { ...requestConfig(), params: { viewId } });
};

const getData = (user: string, viewId: number | string, groupcode?: string, environment?: string, amountOfRecords?: string, columns?: string, filterColumns?: any, filterValues?: any, filterCodes?: string, issueCategory?: string, issueField?: string, issueDescription?: string) => {
    const http = getAxiosInstance();
    return http.get(`${ROUTE_NAME}/data`, {
        ...requestConfig(),
        params: { user, viewId, groupcode, environment, amountOfRecords, columns, filterColumns, filterValues, filterCodes, issueCategory, issueField, issueDescription },
    });
};

const getDataTypes = (viewId: number) => {
    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/datatypes`, { ...requestConfig(), params: { viewId } });
};

const getReferenceAllowedValues = (fieldId: number) => {
    const http = getAxiosInstance();
    return http.get<string[]>(`${ROUTE_NAME}/referenceAllowedValues`, { ...requestConfig(), params: { fieldId } });
};

const getIssues = (user: string, viewId: number | string, entity: string, groupCode: string, environment: string, amountOfRecords: string, columns?: string, codes?: string, filterColumns?: any, filterValues?: any, issueCategory?: string, issueField?: string, issueDescription?: string) => {
    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/issues`, {
        ...requestConfig(),
        params: { user, viewId, entity, groupCode, environment, amountOfRecords, columns, codes, filterColumns, filterValues, issueCategory, issueField, issueDescription },
    });
};

const getAggregatedIssues = (user: string, viewId: number | string, entity: string, groupCode: string, environment: string, columns?: string, codes?: string, filterColumns?: any, filterValues?: any) => {
    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/aggregatedIssues`, {
        ...requestConfig(),
        params: { user, viewId, entity, groupCode, environment, columns, codes, filterColumns, filterValues },
    });
};

const getFieldsWithUpdates = (viewId: number | string) => {
    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/FieldsWithUpdates`, { ...requestConfig(), params: { viewId } });
};

const getUpdates = (viewId: number | string, column: string, code: string) => {
    const http = getAxiosInstance();
    return http.get<any[]>(
        `${ROUTE_NAME}/Updates`,
        { ...requestConfig(), params: { viewId, column, code } }
    );
};

const getLabels = (viewId: number) => {
    const http = getAxiosInstance();
    return http.get<any[]>(`${ROUTE_NAME}/Labels`, { ...requestConfig(), params: { viewId } });
};

const publish = (
    user: string,
    viewId: number | string,
    environment: string | undefined,
    groupCode: string | undefined,
    jsonData: string
) => {
    const http = getAxiosInstance();
    return http.post(
        `${ROUTE_NAME}/publish`,
        { user, viewId, environment, groupCode, jsonData },
        {
            ...requestConfig(),
        }
    );
};

const deleteRow = (user: string, viewId: number | string, jsonData: string) => {
    const http = getAxiosInstance();
    return http.post(
        `${ROUTE_NAME}/delete`,
        { user, viewId, jsonData },
        {
            ...requestConfig(),
        }
    );
};


const DatashaperService = {
    getReferenceAllowedValues,
    getEntities,
    getGroupCodes,
    getTables,
    getEnvironments,
    getEditableFields,
    getVisibleFields,
    getData,
    getDataTypes,
    getIssues,
    getAggregatedIssues,
    getFieldsWithUpdates,
    getUpdates,
    getLabels,
    publish,
    deleteRow
};




export default DatashaperService;
